import { render } from "./removeFloader.vue?vue&type=template&id=f4e87ed4"
import script from "./removeFloader.vue?vue&type=script&lang=js"
export * from "./removeFloader.vue?vue&type=script&lang=js"

import "./removeFloader.vue?vue&type=style&index=0&id=f4e87ed4&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__